import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MapPin2Icon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M12 17.825c-.22 0-.44-.07-.62-.22-.26-.21-6.38-5.12-6.38-9.65 0-3.86 3.21-7.13 7-7.13s7 3.27 7 7.14c0 4.52-6.12 9.44-6.38 9.65-.18.15-.4.22-.62.22v-.01zm0-15c-2.71 0-5 2.35-5 5.14 0 2.62 3.19 5.96 5 7.56 1.81-1.6 5-4.94 5-7.56 0-2.78-2.29-5.14-5-5.14z"
                        }),
                        _jsx("path", {
                            d: "M12 10.825c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm10 16.35H2a1.005 1.005 0 01-.94-1.35l2.04-5.57c.14-.39.52-.66.94-.66H6c.55 0 1 .45 1 1s-.45 1-1 1H4.74l-1.31 3.57h17.14l-1.31-3.57H18c-.55 0-1-.45-1-1s.45-1 1-1h1.96c.42 0 .79.26.94.66l2.04 5.57a1.005 1.005 0 01-.94 1.35z"
                        })
                    ]
                })
            })
        ]
    });
};
MapPin2Icon.isCarinaIcon = true;
export default MapPin2Icon;
